/**
 * @todo add/update JSDoc tags to document your code
 * (see http://usejsdoc.org/ for information on JSDoc tags),
 * then remove this comment block.
 */

/** PageFooter Reducer */

/** @todo import a constant for each action the reducer supports */
import { FOOTER_BUTTONS_SETUP } from './page-footer-actions';

/**
 * @todo - when the application starts, the reducer will be called with 'state' undefined.
 * The reducer is not allowed to return undefined, so give the const 'initialState' a sane value,
 * so it can be used as the default value for reducer's 'state' parameter.
 */
const initialState = {
    leftSideButtons: [],
    rightSideButtons: []
};

export default function (state = initialState, action) {
    if (!action) return state;
    const payload = action.payload;
    switch (action.type) {
    /** @todo - add real actions consumed by this reducer */
    case FOOTER_BUTTONS_SETUP:
        return {
            ...state,
            leftSideButtons: payload.leftButtons,
            rightSideButtons: payload.rightButtons
        };

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/page-footer/page-footer-reducer.js